'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SpectoForm = function () {
    function SpectoForm() {
        var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

        _classCallCheck(this, SpectoForm);

        this.forms = 'form[data-specto-form]';
        if (!settings.length) {
            this.setSettings(settings);
        }

        this.cacheDOM();
        this.bindEvents();
        this.onLoad();
    }

    _createClass(SpectoForm, [{
        key: 'setSettings',
        value: function setSettings(settings) {
            var _this = this;

            $.each(settings, function (key, val) {
                if (_this.hasOwnProperty(key) || _this.hasOwnProperty('$' + key)) {
                    _this[key] = val;
                }
            });
        }
    }, {
        key: 'cacheDOM',
        value: function cacheDOM() {}
    }, {
        key: 'bindEvents',
        value: function bindEvents() {
            $(document).on('submit', this.forms, this.submitForm.bind(this));
        }
    }, {
        key: 'onLoad',
        value: function onLoad() {
            SpectoForm.ajaxLoad();
            // toggle checkbox - knowledge form
            $('#chk-20').removeAttr('Checked');
        }
    }, {
        key: 'submitForm',
        value: function submitForm(e) {
            e.preventDefault();
            e.stopPropagation();

            var submittedForm = $(e.target);
            var formID = submittedForm.attr('id');

            if (formID !== "undefined") {
                var type = submittedForm.attr('method').toUpperCase();
                var parameters = submittedForm.serialize();
                submittedForm.find('.form-group.has-error').removeClass('has-error');
                submittedForm.find('p.error-msg').remove();
                //console.log(parameters);


                //let formUrl = window.location.origin + '/api/v1/formApi/form-data'; // link to specto custom validation


                $.ajax({
                    url: window.location.origin + '/api/v1/formApi/form-data',
                    type: type,
                    data: parameters,
                    success: function success(response) {
                        submittedForm.next('.thank-you-form').show();
                        submittedForm.remove();
                        //console.log("SUCCESS");
                    },
                    error: function error(response) {
                        $.each(response.responseJSON.msg, function () {
                            $('[id^=' + this.field + ']').closest('.form-group').addClass('has-error');
                        });

                        if (submittedForm.find('.form-group.has-error').length > 0) {
                            $('html, body').animate({
                                scrollTop: submittedForm.find('.form-group.has-error').first().offset().top - 100
                            }, 500);
                        }

                        if ($("body").hasClass("sl-page")) {
                            $(".contact-form .btn").before("<p class='error-msg'>Obvezna polja morajo biti pravilno izpolnjena.</p>");
                        } else {
                            $(".contact-form .btn").before("<p class='error-msg'>All fields are required.</p>");
                        }
                    }
                });
            }
        }
    }], [{
        key: 'ajaxLoad',
        value: function ajaxLoad() {
            $(document).ajaxStart(function () {
                $("#ajaxLoader").show();
            });
            $(document).ajaxStop(function () {
                $("#ajaxLoader").hide();
            });
        }
    }]);

    return SpectoForm;
}();